<!--
    描述：电子保函 -> 退保申请
    时间：2023-02-08
    Created by zcc
-->
<template>
	<div class="bh-main operation-layout" :class="{ pd0: !routeQuery }">
		<!-- 列表查询页 -->
		<filter-layout @search="doSearch" @reset="doReset" v-if="!routeQuery" hasMore>
			<template #filter>
				<el-form class="flex-row-form colspan-4" size="small" ref="searchRef" :model="searchForm" label-width="130px">
					<el-form-item label="申请退保单位：" prop="tenantName">
						<el-input :placeholder="'请输入'" clearable v-model="searchForm.tenantName"> </el-input>
					</el-form-item>
					<el-form-item label="瀚华保函编号：" prop="guaranteeNumber">
						<el-input :placeholder="'请输入'" clearable v-model="searchForm.guaranteeNumber"> </el-input>
					</el-form-item>
					<el-form-item label="标段名称：" prop="bidName">
						<el-input :placeholder="'请输入'" clearable v-model="searchForm.bidName"> </el-input>
					</el-form-item>
					<el-form-item label="标段编号：" prop="bidNo">
						<el-input :placeholder="'请输入'" clearable v-model="searchForm.bidNo"> </el-input>
					</el-form-item>
				</el-form>
			</template>
			<template #more>
				<el-form class="flex-row-form colspan-4" size="small" ref="searchRef" :model="searchForm" label-width="130px">
					<el-form-item label="标段状态" prop="sectionStatus">
						<el-select v-model="searchForm.sectionStatus" :placeholder="'请选择'" size="small" clearable>
							<el-option v-for="(item, index) in sectionStatusList" :key="index" :value="item.value" :label="item.label"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="退保状态" prop="status">
						<el-select v-model="searchForm.status" :placeholder="'请选择'" size="small" clearable>
							<el-option v-for="(item, index) in statusList" :key="index" :value="item.value" :label="item.label"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="申请时间" prop="dateArr" class="date-time">
						<el-date-picker
							v-model="searchForm.dateArr"
							type="daterange"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							value-format="yyyy-MM-dd"
						></el-date-picker>
					</el-form-item>
				</el-form>
			</template>
			<template #content>
				<!-- 非请求参数 正常查看 -->
				<div class="operation-main">
					<div class="operation-header">
						<div class="title">
							合计退保申请记录：<span class="blue">{{ tableObj.total }}</span> 个
						</div>
						<div class="btnGroups"></div>
					</div>
					<div class="operation-container w-table-layout w-table-page">
						<div class="w-table-content" v-show="tableShow">
							<el-table ref="xTable" :data="tableObj.data" highlight-current-row height="100%" size="mini" border>
								<el-table-column type="index" label="" width="50" align="center"> </el-table-column>
								<el-table-column prop="id" label="业务流水号" align="center" width="180" show-overflow-tooltip> </el-table-column>
								<el-table-column
									prop="guaranteeNumber"
									label="瀚华保函编号"
									align="center"
									width="180"
									show-overflow-tooltip
								></el-table-column>
								<el-table-column
									prop="tenantName"
									label="申请退保单位"
									align="center"
									width="150"
									show-overflow-tooltip
								></el-table-column>
								<el-table-column prop="bidName" label="标段名称" align="center" width="200" show-overflow-tooltip></el-table-column>
								<el-table-column prop="bidNo" label="标段编号" width="180" align="center" show-overflow-tooltip></el-table-column>
								<el-table-column prop="sectionStatus" label="瀚华标段状态" width="120" align="center" show-overflow-tooltip>
									<template slot-scope="scope">
										<span v-if="scope.row.sectionStatus == '1'">撤标</span>
										<span v-else-if="scope.row.sectionStatus == '2'">流标</span>
										<span v-else-if="scope.row.sectionStatus == '3'">延标</span>
										<span v-else-if="scope.row.sectionStatus == '4'">中标</span>
										<span v-else-if="scope.row.sectionStatus == '5'">其它</span>
										<span v-else> - </span>
									</template>
								</el-table-column>
								<el-table-column
									prop="applyUserName"
									label="申请人"
									width="119"
									align="center"
									show-overflow-tooltip
								></el-table-column>
								<el-table-column prop="createDate" label="申请时间" width="180" align="center" show-overflow-tooltip>
								</el-table-column>
								<el-table-column
									prop="sysSourceName"
									label="业务来源"
									width="120"
									align="center"
									show-overflow-tooltip
								></el-table-column>
								<el-table-column prop="status" label="退保状态" width="100" align="center" show-overflow-tooltip>
									<template slot-scope="scope">
										<span v-if="scope.row.status == '1'" class="status-img">
											<img src="../../../../assets/images/between.png" alt="" />
											退保处理中
										</span>
										<span v-else-if="scope.row.status == '2'" class="status-img">
											<img src="../../../../assets/images/success.png" alt="" />
											退保成功
										</span>
										<span v-else-if="scope.row.status == '3'" class="status-img">
											<img src="../../../../assets/images/fail.png" alt="" />
											退保失败
										</span>
									</template>
								</el-table-column>
								<el-table-column align="center" width="100">
									<template slot="header">操作</template>
									<template slot-scope="scope">
										<el-button type="primary" size="small" round plain class="table-btn" @click="showDetail(scope.row)">
											<svg-icon icon-class="form-details"></svg-icon>
											详情
										</el-button>
									</template>
								</el-table-column>
							</el-table>
						</div>
						<div class="w-table-footer">
							<el-pagination
								@size-change="handleSizeChange"
								@current-change="handleCurrentChange"
								:current-page="tableObj.currentPage"
								:page-sizes="tableObj.pageList"
								:page-size="tableObj.pageSize"
								:total="tableObj.total"
								layout="total, sizes, prev, pager, next, jumper"
							>
							</el-pagination>
						</div>
					</div>
				</div>
			</template>
		</filter-layout>

		<!-- 详情页 -->
		<template v-else>
			<memberDetail ref="memberDetail"></memberDetail>
		</template>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import memberDetail from './components/detail'
import * as API from 'api/modules/bh/bh-surrender-application'
export default {
	name: 'bh-surrender-application-index',
	components: {
		memberDetail
	},
	data() {
		return {
			btnLoading: false,
			searchToggle: true,
			tableShow: true,
			//会员类型下拉信息
			accountTypeDL: [],
			//证件类型
			certTypeDL: [],

			searchForm: {
				tenantName: '', //申请退保单位
				guaranteeNumber: '', //瀚华保函编号
				bidName: '', //标段名称
				bidNo: '', //标段编号
				sectionStatus: '', //标段状态
				status: '', //退保状态
				dateArr: [],
				createDataStart: null,
				createDataEnd: null
			},

			sectionStatusList: [
				{
					label: '全部',
					value: ''
				},
				{
					label: '撤标',
					value: '1'
				},
				{
					label: '流标',
					value: '2'
				},
				{
					label: '延标',
					value: '3'
				},
				{
					label: '中标',
					value: '4'
				},
				{
					label: '其它',
					value: '5'
				}
			], //标段状态

			statusList: [
				{
					label: '全部',
					value: ''
				},
				{
					label: '退保处理中',
					value: '1'
				},
				{
					label: '退保成功',
					value: '2'
				},
				{
					label: '退保失败',
					value: '3'
				}
			], //退保状态

			tableObj: {
				data: [],
				currentPage: 1, // 当前页码
				pageList: [10, 20, 50, 100], // 显示条数数组
				pageSize: 10, // 当前显示条数
				total: 0 // 当前总条数
			}
		}
	},
	watch: {
		// 监听 筛选元素的 切换展示 重新调整表格高度
		searchToggle() {
			this.tableShow = false
			setTimeout(() => {
				this.tableShow = true
			}, 50)
			setTimeout(() => {
				this.$refs.xTable.doLayout()
			}, 1000)
		}
	},
	computed: {
		...mapState('app', { isBack: (state) => state.isBack }),
		...mapState('menu', {
			roleBtns: (state) => state.roleBtns
		}),
		routeQuery() {
			return this.$route.query.type
		}
	},
	created() {
		// 如果是 返回的
		if (this.isBack) {
			if (this.$getSessionItem('params')) {
				let params = JSON.parse(this.$getSessionItem('params'))
				Object.keys(this.searchForm).forEach((key) => (this.searchForm[key] = params[key]))
				this.tableObj.currentPage = params.currentPage
				this.tableObj.pageSize = params.pageSize
				// 移除 避免污染
				this.$removeSessionItem('params')
			}
		}
		this.getSelectSurrenderList()
	},
	methods: {
		//查询
		doSearch() {
			this.getSelectSurrenderList()
		},
		//获取分页列表信息
		getSelectSurrenderList() {
			this.tableObj.data = []
			if (this.searchForm.dateArr && this.searchForm.dateArr.length > 0) {
				this.searchForm.createStartDate = this.searchForm.dateArr[0] + ' 00:00:00'
				this.searchForm.createEndDate = this.searchForm.dateArr[1] + ' 23:59:59'
			} else {
				this.searchForm.createStartDate = ''
				this.searchForm.createEndDate = ''
			}
			let param = Object.assign({}, this.searchForm)
			param.current = this.tableObj.currentPage
			param.size = this.tableObj.pageSize
			API.getSelectSurrenderList(param).then((res) => {
				if (res.operationCode == 1) {
					this.tableObj.data = res.data.records
					this.tableObj.total = parseInt(res.data.total)
				}
			})
		},
		//重置查询
		doReset() {
			Object.keys(this.searchForm).forEach((key) => (this.searchForm[key] = ''))
			this.searchForm.createStartDate = null
			this.searchForm.createEndDate = null
			this.searchForm.dateArr = []
			this.tableObj.pageSize = 10
			this.tableObj.currentPage = 1
			this.getSelectSurrenderList()
		},
		//操作-详情
		showDetail(row) {
			let params = Object.assign({}, this.searchForm)
			params.currentPage = this.tableObj.currentPage
			params.pageSize = this.tableObj.pageSize
			this.$setSessionItem('params', JSON.stringify(params))
			this.$router.push({
				path: 'bh-surrender-application-index',
				query: {
					type: 'memberDetail',
					id: row.id
				}
			})
		},
		//刷新
		reFresh() {
			Object.keys(this.searchForm).forEach((key) => (this.searchForm[key] = ''))
			this.tableObj.pageSize = 10
			this.tableObj.currentPage = 1
			this.getSelectSurrenderList()
		},
		// 切换显示条数
		handleSizeChange(val) {
			this.tableObj.pageSize = val
			this.getSelectSurrenderList()
		},
		//切换当前页码
		handleCurrentChange(val) {
			this.tableObj.currentPage = val
			this.getSelectSurrenderList()
		},
		// 是否展开搜索区域
		changeState() {
			this.searchToggle = !this.searchToggle
		},
		// 开始时间的 pickOption
		beginDate() {
			let that = this
			return {
				disabledDate(time) {
					let endTime = that.searchForm.createDataEnd
					if (endTime) {
						return time.getTime() >= new Date(endTime).getTime()
					} else return false
				}
			}
		},
		// 结束时间的 pickOption
		processDate() {
			let that = this
			return {
				disabledDate(time) {
					let startTime = that.searchForm.createDataStart
					if (startTime) {
						return time.getTime() <= new Date(startTime).getTime()
					} else return false
				}
			}
		},
		// 返回
		goBack() {
			this.$router.push({ path: '/bh-surrender-application-index' })
		}
	}
}
</script>

<style lang="less" scoped>
.operation-layout.pd0 {
	padding: 0;
}
.bh-main {
	.filter-box {
		padding-top: 5px;
	}

	/deep/ .search-form {
		.el-col {
			height: 48px;
		}

		.text-center {
			display: flex;
			align-items: center;
			justify-content: center;
		}
	}

	.blue-text {
		color: #2671cc;
		cursor: pointer;
	}

	.blue-text:hover {
		color: blue;
	}

	.el-switch.is-disabled {
		opacity: 1;
	}

	/deep/ .el-switch.is-disabled .el-switch__core,
	/deep/ .el-switch.is-disabled .el-switch__label {
		cursor: pointer !important;
	}
}
.w-table-content {
	/deep/ .el-radio__label {
		display: none;
	}
}
.label-tooltip {
	max-width: 600px;
	max-height: 140px;
	overflow-y: auto;
	overflow-x: hidden;
}

.primary-dialog {
	/deep/ .el-dialog__body {
		padding: 30px;
	}

	.row-label {
		height: 40px;
		line-height: 40px;
		padding-right: 15px;
	}

	.row-btn {
		padding-left: 10px;
		width: 100%;
	}

	.tags-container {
		line-height: 40px;
		max-height: 120px;
		overflow-y: auto;

		/deep/ .el-tag {
			cursor: pointer;
		}
	}

	.tags-all-container {
		line-height: 30px;
		max-height: 300px;
		overflow-y: auto;

		/deep/ .el-tag {
			cursor: pointer;
		}
	}
}

.status {
	.switch > .el-switch__label--right > span {
		margin-left: 0 !important;
		margin-right: 15px !important;
	}
}

.status-img {
	display: flex;
	align-items: center;
	justify-content: center;

	img {
		margin-right: 5px;
	}
}
</style>
